import { render, staticRenderFns } from "./AWeekPicker.vue?vue&type=template&id=48e47d5c"
import script from "./AWeekPicker.ts?vue&type=script&lang=ts&external"
export * from "./AWeekPicker.ts?vue&type=script&lang=ts&external"
import style0 from "./AWeekPicker.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports